import * as React from 'react';
import { SVGAttributes } from 'react';

export const GcpIcon = ({ color, ...rest }: SVGAttributes<SVGElement>) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.88127 9.51861C2.37291 10.0272 2.37291 10.8505 2.88127 11.3591L5.13941 13.6184C5.64799 14.1272 6.47152 14.1272 6.9801 13.6184L8.4974 12.1003L10.0147 13.6184C10.2779 13.8817 10.6129 13.9987 10.9376 13.9987C11.2804 13.9987 11.6017 13.8648 11.8462 13.6324L11.8535 13.6255L14.1187 11.3591C14.6271 10.8505 14.6271 10.0272 14.1187 9.51861L12.5964 7.99931L14.1135 6.48139C14.6219 5.97277 14.6219 5.14951 14.1135 4.64089L11.8554 2.38162C11.3468 1.87279 10.5233 1.87279 10.0147 2.38162L8.4974 3.89968L6.97301 2.37453L6.96573 2.36762C6.72118 2.13517 6.39986 2.0013 6.05715 2.0013C5.72715 2.0013 5.39041 2.1305 5.13941 2.38162L2.88127 4.64089C2.37291 5.14951 2.37291 5.97277 2.88127 6.48139L4.39913 8L2.88127 9.51861ZM6.41304 8.00288L8.50288 10.087L10.587 7.99712L8.50288 5.91304L6.41304 8.00288Z"
        fill={color}
      />
    </svg>
  );
};
